"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHex = exports.withoutOpacity = void 0;
var parseColor = require("color");
function withoutOpacity(value) {
    return parseColor(value)
        .alpha(1)
        .rgb()
        .string();
}
exports.withoutOpacity = withoutOpacity;
function withHex(value) {
    return parseColor(value).hex();
}
exports.withHex = withHex;
//# sourceMappingURL=color.js.map